import React from 'react';
// If using EmailJS, install and import: import emailjs from 'emailjs-com';

function Contact() {
  return (
    <div className="container py-4">
      <h1 className="display-4 mb-4 text-center">Contact Us</h1>
      <p className="lead text-center mb-4">
        We love hearing from curious minds! <br />
        Share your questions, ideas, or discoveries below. Our team will get back to you soon.
      </p>

      <div style={{ maxWidth: 640, margin: '0 auto', textAlign: 'center' }}>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSfaN5v8iNM2hV_WLpNALtC0aA0xD-BDRK2vRLsg8oaKXJC5Mw/viewform?embedded=true"
          width="100%"
          height="1300"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="BioEra Contact Form"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
}

export default Contact;
